import {
  getMinorNightWorkDefaultRequest,
  saveMinorNightWorkDefaultRequest,
} from 'api/requests/contract-compliance-requests';
import { MinorNightWorkRule } from 'constants/MinorNightWorkRule';
import { IMinorNightWorkRuleDefault, ISaveMinorNightWorkDefault } from 'types/contract-compliance/IContractCompliance';
import { RuleDefaultAdapter } from '../hooks/useRuleDefaultPanel';
import {
  isNightWorkDefaultComplete,
  NightWorkDefaultDraft,
  toNightWorkDefaultDraft,
  toSaveNightWorkDefaultBody,
  validateNightWorkDefaultDraft,
} from './utils';

export const minorNightWorkDefaultAdapter: RuleDefaultAdapter<
  MinorNightWorkRule,
  IMinorNightWorkRuleDefault,
  NightWorkDefaultDraft,
  ISaveMinorNightWorkDefault
> = {
  emptyDraft: { start: '', end: '', minAge: '', maxAge: '' },
  load: getMinorNightWorkDefaultRequest,
  save: saveMinorNightWorkDefaultRequest,
  toDraft: toNightWorkDefaultDraft,
  validate: validateNightWorkDefaultDraft,
  isComplete: isNightWorkDefaultComplete,
  toBody: toSaveNightWorkDefaultBody,
};
